import {
    SavedProfile,
    DeliveryMethod,
    DeliveryMethodSelection,
    SellerDeliveryForm,
} from './checkoutTypes';
import { ShippingMethod } from '../../types';

export const ALL_METHODS: DeliveryMethod[] = [
    'nova_poshta',
    'ukrposhta',
    'pickup',
];

export function normalizeMethods(
    methods?: ShippingMethod[],
    availableMethods: DeliveryMethod[] = ALL_METHODS,
): DeliveryMethod[] {
    const available = availableMethods.length ? availableMethods : ALL_METHODS;

    if (methods === undefined) {
        return available;
    }

    const normalized = Array.from(
        new Set(methods.map((m) => m.toString())),
    ).filter((m): m is DeliveryMethod =>
        available.includes(m as DeliveryMethod),
    );

    return normalized;
}

export function buildInitialForm(
    method: DeliveryMethodSelection,
    saved: {
        nova_poshta: SavedProfile | null;
        ukrposhta: SavedProfile | null;
    },
): SellerDeliveryForm {
    const profile =
        method === 'nova_poshta'
            ? saved?.nova_poshta
            : method === 'ukrposhta'
              ? saved?.ukrposhta
              : null;

    return {
        method,
        recipient_name: profile?.recipient_name ?? '',
        recipient_phone: profile?.recipient_phone ?? '',
        city: profile?.city ?? '',
        region: profile?.region ?? '',
        delivery_point_type:
            (profile?.delivery_point_type as 'branch' | 'parcel_locker') ??
            'branch',
        delivery_point_number: profile?.delivery_point_number ?? '',
        post_office: profile?.post_office ?? '',
        comment_for_seller: '',
        nova_poshta_city_ref: profile?.nova_poshta_city_ref ?? '',
        nova_poshta_city_name: profile?.nova_poshta_city_name ?? '',
        nova_poshta_warehouse_ref: profile?.nova_poshta_warehouse_ref ?? '',
        nova_poshta_warehouse_number:
            profile?.nova_poshta_warehouse_number ?? '',
        nova_poshta_warehouse_address:
            profile?.nova_poshta_warehouse_address ?? '',
        ukrposhta_settlement_ref: profile?.ukrposhta_settlement_ref ?? '',
        ukrposhta_settlement_name: profile?.ukrposhta_settlement_name ?? '',
        ukrposhta_post_office_ref: profile?.ukrposhta_post_office_ref ?? '',
        ukrposhta_post_office_index: profile?.ukrposhta_post_office_index ?? '',
        ukrposhta_post_office_address:
            profile?.ukrposhta_post_office_address ?? '',
        ukrposhta_post_office_name: profile?.ukrposhta_post_office_name ?? '',
    };
}

export function savedProfileForMethod(
    method: DeliveryMethodSelection,
    saved: {
        nova_poshta: SavedProfile | null;
        ukrposhta: SavedProfile | null;
    },
) {
    if (method === 'nova_poshta') return saved?.nova_poshta;
    if (method === 'ukrposhta') return saved?.ukrposhta;
    return null;
}

export function hasRequiredSavedFields(
    method: DeliveryMethodSelection,
    profile: SavedProfile | null | undefined,
) {
    if (!profile) return false;

    if (method === 'nova_poshta') {
        return Boolean(
            profile.recipient_name?.trim() &&
                profile.recipient_phone?.trim() &&
                profile.city?.trim() &&
                profile.delivery_point_number?.trim() &&
                profile.nova_poshta_city_ref?.trim() &&
                profile.nova_poshta_warehouse_ref?.trim(),
        );
    }

    if (method === 'ukrposhta') {
        return Boolean(
            profile.recipient_name?.trim() &&
                profile.recipient_phone?.trim() &&
                profile.city?.trim() &&
                profile.post_office?.trim(),
        );
    }

    return false;
}

export function extractItemName(name: string) {
    return name.replace(/\s*\(від [^)]+\)\s*$/, '').trim();
}
